import Proptypes from "prop-types";
import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ClickLayer } from "../../../ga4";

import { BuyModal } from 'Components/modal';
import { Image } from 'Components/commonComponents';
import cart_logo from 'Images/new/shop_icons/cart_logo.png';

const BtnBuyModal = ({
  btnText= 'Shop Now',
}) => {
  const [buyModal, setBuyModal] = useState(false);
  const onCloseBuy = () => {
    ClickLayer('closeBuyModal');
    setBuyModal(false);
  };

  const onOpenBuy = () => {
    ClickLayer('openBuyModal');
    setBuyModal(true);
  };

  return (
    <Fragment>
      <a
        onClick={onOpenBuy}
        className='tabs--item tabs--color__fresh tabs--item__buy'
      >
        <Image
          src={cart_logo}
          className='img-responsive icons--cart'
        />
        <FormattedMessage
              id="modal.buy_button"
              defaultMessage="Shop Now"
        />
      </a>
      {buyModal && <BuyModal onClose={onCloseBuy} />}
    </Fragment>
  );
};

export default BtnBuyModal;

BtnBuyModal.propTypes = {
  btnText: Proptypes.string,
};
